module.exports = __webpack_public_path__ + "media/images/img/tag_company/diva_tag-06f223fb448864a75513575ccbaa9b97.png";